// extracted by mini-css-extract-plugin
var _1 = "ProfileUsersWidgetItem-moduleProfileUsersWidgetItem__ws8ul UserListItem-moduleUserListItem__BHphF";
var _2 = "ProfileUsersWidgetItem-modulehover__rY89e";
export { _1 as "ProfileUsersWidgetItem", _2 as "hover" }
